import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalendarCheck, User } from "lucide-react";
import {
  DateField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "../common";
import { LeaveApprovalActions } from "./LeaveApprovalActions";

export const LeaveRequestShow = () => (
  <Show actions={<LeaveApprovalActions />}>
    <Card className="form-container">
      <div className="form-header-premium">
        <CalendarCheck className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Leave Request Details</h2>
      </div>
      <SimpleShowLayout>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <Card>
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500 flex items-center gap-2">
                <User className="w-3.5 h-3.5" /> Employee Information
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 space-y-3">
              <ReferenceField source="employee_id" reference="employees">
                <TextField source="name" className="employee-name" />
              </ReferenceField>
              <ReferenceField source="leave_type_id" reference="hr_leave_types">
                <TextField source="name" className="font-medium" />
              </ReferenceField>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Duration & Status
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 space-y-3">
              <div className="flex justify-between items-center">
                <DateField source="from_date" className="text-sm" />
                <span className="text-xs text-slate-400">to</span>
                <DateField source="to_date" className="text-sm" />
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-semibold">{`Days: `}<TextField source="days" /></span>
                <TextField source="status" className="status-bookmark" />
              </div>
            </CardContent>
          </Card>
          <Card className="md:col-span-2">
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Reason & Approval
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 space-y-4">
              <div>
                <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">Reason</span>
                <TextField source="reason" className="text-sm italic text-slate-600" />
              </div>
              <div className="grid grid-cols-2 gap-4 pt-2 border-t">
                <div>
                  <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">Approver</span>
                  <ReferenceField source="approver_id" reference="employees" emptyText="Not yet approved">
                    <TextField source="name" className="text-sm" />
                  </ReferenceField>
                </div>
                <div>
                  <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">Approved At</span>
                  <DateField source="approved_at" showTime className="text-sm" emptyText="—" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </SimpleShowLayout>
    </Card>
  </Show>
);

